import { useQuery } from "@tanstack/react-query";
import fetcher from "src/utils/fetcher";
import { useAuth } from "src/components/utils/auth/assist/authContext";
import useAccount from "src/hooks/useAccount";

interface InkedEmbedUrlResponse {
  signedUrl: string;
}

export const useInkedEmbedUrl = (enabled = false) => {
  const { user } = useAuth();
  const { data: accountData } = useAccount();

  return useQuery({
    queryKey: ["inkedEmbedUrl", accountData?.user_id],
    queryFn: async () => {
      // User data to pass in signed URL request
      const userData = {
        target_user_email: user?.email || "",
        target_user_first_name: user?.first_name || "",
        target_user_last_name: user?.last_name || "",
        target_user_company: accountData?.brokerage || "",
        target_user_external_id: accountData?.user_id ? String(accountData.user_id) : "",
        target_user_phone: user?.mobile_phone || "",
      };

      // Use different endpoints based on environment
      if (window.location.hostname === 'localhost') {
        // On localhost, use the direct Inked API with vendor headers
        const getSignedUrlApiUrl = `${process.env.REACT_APP_INKED_API_URL}/vendor/embed`;
        console.log("getSignedUrlApiUrl", getSignedUrlApiUrl);

        const fetchResponse = await fetch(getSignedUrlApiUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Vendor-Key': process.env.REACT_APP_INKED_VENDOR_KEY || '',
          },
          body: JSON.stringify(userData)
        });

        if (!fetchResponse.ok) {
          throw new Error(`API request failed: ${fetchResponse.status}`);
        }

        const data = await fetchResponse.json();
        return data.signedUrl;
      } else {
        // In production, use the Landvoice API endpoint
        const response = await fetcher({
          url: `/api/inked/signed-url`,
          method: 'POST',
          body: userData,
        });

        const data = response.data as InkedEmbedUrlResponse;
        return data.signedUrl;
      }
    },
    enabled: enabled && !!user && !!accountData?.user_id,
    staleTime: 0, // Always consider data stale
    gcTime: 0, // Don't keep in cache
    retry: 2,
  });
};